import React from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Send as SendIcon,
} from '@mui/icons-material';
import CustomButton from '../../../../components/General/CustomButton';
import useStyles from './styles';

interface SendConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

function SendConfirmModal({
  open,
  onClose,
  onConfirm,
  loading = false,
}: SendConfirmModalProps) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modalContainer}>
        <Card className={classes.modal}>
          <CardContent className={classes.modalContent}>
            <Box className={classes.modalTitleContainer}>
              <Box className={classes.modalTitleAndIcon}>
                <Typography variant="h4" color="primary" fontWeight="bold">
                  Enviar plan de estudios
                </Typography>
              </Box>
              <IconButton onClick={onClose} disabled={loading}>
                <CloseIcon color="primary" />
              </IconButton>
            </Box>
            <Box className={classes.modalBody}>
              <Typography variant="body1" textAlign="center">
                Revisa cuidadosamente los valores y descuentos
                antes de enviar el plan de estudios.
                <br />
                <strong> Una vez aceptado, no podrá ser editado.</strong>
              </Typography>
            </Box>
            <Box className={classes.modalButtonsContainer}>
              <CustomButton
                text="Cancelar"
                colorType="tertiary"
                onClick={onClose}
                disabled={loading}
                icon={<CloseIcon />}
              />
              <CustomButton
                text="Enviar"
                colorType="primary"
                onClick={onConfirm}
                disabled={loading}
                loading={loading}
                icon={<SendIcon />}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
}

export default SendConfirmModal;
